import React, { Component } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import classes from './Layout.module.css';

import Notifications from '../../components/Notifications/Notifications';

class Layout extends Component {
    state = {
        bookShow: false
    }

    bookShowToggle = () => {
        this.setState({ bookShow: !this.state.bookShow });
    }

    unloadMessage = () => {
        this.props.onUnloadMessage();
    }

    render() {
        return (
            <div className={classes.Container}>
                <Header
                    role={this.props.role}
                    bookShowToggle={this.bookShowToggle}
                    bookShow={this.state.bookShow}
                    isLoggedIn={this.props.isLoggedIn}
                    currentId={this.props.currentId} />
                <Notifications message={this.props.message} style={this.props.style} clicked={this.unloadMessage} />
                <main className={classes.Content}>
                    {this.props.children}
                </main>
                <Footer />
            </div >
        );
    }
}

const mapStateToProps = state => {
    return {
        message: state.notifications.message,
        style: state.notifications.style,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onUnloadMessage: () => dispatch(actions.unloadMessage())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);